import React, { useState, useEffect } from 'react';
import { db, auth, analytics } from '../backend/firebaseConfig';
import { logEvent } from 'firebase/analytics';
import { getDoc, doc, updateDoc, deleteDoc, setDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import Navbar from '../Navbar';
import '../styles/EditClothing.css';
import TagInput from './TagInput';

const EditClothing = () => {
    const { clothingId } = useParams();
    const { type } = useParams();
    const [image, setImage] = useState('');
    const [tags, setTags] = useState([]);
    const [title, setTitle] = useState('');
    const [newTitle, setNewTitle] = useState(''); 
    const [newType, setNewType] = useState(type);

    useEffect(() => {
        const user = auth.currentUser;
        const fetchData = async () => {
            if (type == 'top') {
                const clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/top/items`, clothingId);
                const clothingData = await getDoc(clothingDoc);
    
                if (clothingData.exists()) {
                    const data = clothingData.data();
                    console.log(clothingData.data());
                    setImage(data.url);
                    setTags(data.tags);
                    setTitle(data.title);
                    setNewTitle(data.title);
                }
                else {
                    console.log("DNF");
                }
            }
            else if (type == 'bottom') {
                const clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/bottom/items`, clothingId);
                const clothingData = await getDoc(clothingDoc);
    
                if (clothingData.exists()) {
                    const data = clothingData.data();
                    console.log(clothingData.data());
                    setImage(data.url);
                    setTags(data.tags);
                    setTitle(data.title);
                    setNewTitle(data.title);
                }
                else {
                    console.log("DNF");
                }
            }
            else if (type == 'shoes') {
                const clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/shoes/items`, clothingId);
                const clothingData = await getDoc(clothingDoc);
    
                if (clothingData.exists()) {
                    const data = clothingData.data();
                    console.log(clothingData.data());
                    setImage(data.url);
                    setTags(data.tags);
                    setTitle(data.title);
                    setNewTitle(data.title);
                }
                else {
                    console.log("DNF");
                }
            }
            else if (type == 'toplayer') {
                const clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/toplayer/items`, clothingId);
                const clothingData = await getDoc(clothingDoc);
    
                if (clothingData.exists()) {
                    const data = clothingData.data();
                    console.log(clothingData.data());
                    setImage(data.url);
                    setTags(data.tags);
                    setTitle(data.title);
                    setNewTitle(data.title);
                }
                else {
                    console.log("DNF");
                }
            }
        };
        fetchData();
    }, [clothingId])

    // Perhaps they can be merged
    const handleUpdateTags = async () => {
        const user = auth.currentUser; // Ensure `user` is defined
        if (!user) {
            console.error("User is not authenticated");
            return;
        }

        
        let clothingDoc;
        if (type === 'top') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/top/items`, clothingId);
        } else if (type === 'bottom') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/bottom/items`, clothingId);
        } else if (type === 'shoes') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/shoes/items`, clothingId);
        } else {
            console.error("Invalid type provided");
            return;
        }
        console.log("clothiing doc:", clothingDoc)
        const uniqueTags = Array.from(new Set(tags.map(tag => tag.trim()).filter(tag => tag !== '')));
        await updateDoc(clothingDoc, { tags: uniqueTags });
        setTags(uniqueTags); // sync cleaned tags

        setTags(uniqueTags);

        console.log('Logging event: tags_updated', { clothing_id: clothingId, type, new_tags: uniqueTags });
        logEvent(analytics, 'tags_updated', {
            clothing_id: clothingId,
            type: type,
            new_tags: uniqueTags,
        });
    }

    const handleTitleChange = (e) => {
        setNewTitle(e.target.value); 
    };

    const handleUpdateTitle = async () => {
        const user = auth.currentUser; // Ensure `user` is defined
        if (!user) {
            console.error("User is not authenticated");
            return;
        }

        
        if (newTitle.trim() === '') {
            alert("Title cannot be empty")
            return; 
        }

        let clothingDoc;
        if (type === 'top') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/top/items`, clothingId);
        } else if (type === 'bottom') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/bottom/items`, clothingId);
        } else if (type === 'shoes') {
            clothingDoc = doc(db, `Users/${user.uid}/ItemsCollection/shoes/items`, clothingId);
        } else {
            console.error("Invalid type provided");
            return;
        }

        await updateDoc(clothingDoc, { title: newTitle });

        setTitle(newTitle);
        setNewTitle(newTitle);

        logEvent(analytics, 'title_updated', {
            clothing_id: clothingId,
            type: type,
            new_title: newTitle,
        });
    }

    const handleTypeChange = async (e) => {
        setNewType(e.target.value);
    };

    const handleUpdateType = async () => {
        const user = auth.currentUser;
        if (!user) {
            console.error('User is not authenticated');
            return;
        }

        if (newType === type) {
            alert('Selected type is the same as the current type');
            return;
        }

        const currentDoc = doc(db, `Users/${user.uid}/ItemsCollection/${type}/items`, clothingId);
        const newDoc = doc(db, `Users/${user.uid}/ItemsCollection/${newType}/items`, clothingId);

        const clothingData = await getDoc(currentDoc);
        if (!clothingData.exists()) {
            console.error('Clothing item not found in the current collection');
            return;
        }

        // Move document to the new collection
        await setDoc(newDoc, clothingData.data());
        await deleteDoc(currentDoc);

        setNewType(newType);
        logEvent(analytics, 'type_updated', { clothing_id: clothingId, old_type: type, new_type: newType });
        alert('Clothing type updated successfully');
    };

    return (
        <div className="edit-clothing-container">
            <Navbar />
            <div className="edit-clothing-content">
                <h1 className="edit-clothing-title">Edit Clothing</h1>
                
                <div className="clothing-preview">
                    {image && <img src={image} alt="Clothing" className="clothing-image" />}
                    
                    {tags.length > 0 && (
                        <div className="current-tags-section">
                            <h3>Current Tags</h3>
                            <div className="tags-container">
                                {tags.map((tag, index) => (
                                    <span key={index} className="tag">{tag}</span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="edit-sections">
                    {/* Update Tags Section */}
                    <div className="edit-section">
                        <h3>Update Tags</h3>
                        <div className="input-group">
                            <TagInput
                            tags={tags}
                            setTags={setTags}
                            />
                            <button className="update-button" onClick={handleUpdateTags}>
                                Update Tags
                            </button>
                        </div>
                    </div>

                    {/* Update Title Section */}
                    <div className="edit-section">
                        <h3>Update Title</h3>
                        <div className="input-group">
                            <input 
                                type="text" 
                                className="form-input"
                                placeholder="Enter a new title" 
                                value={newTitle} 
                                onChange={handleTitleChange}
                            />
                            <button className="update-button" onClick={handleUpdateTitle}>
                                Update Title
                            </button>
                        </div>
                    </div>

                    {/* Change Type Section */}
                    <div className="edit-section">
                        <h3>Change Clothing Type</h3>
                        <div className="input-group">
                            <select 
                                value={newType} 
                                onChange={handleTypeChange}
                                className="form-select"
                            >
                                <option value="top">Top</option>
                                <option value="bottom">Bottom</option>
                                <option value="shoes">Shoes</option>
                                <option value="toplayer">Top Layer</option>
                            </select>
                            <button className="update-button" onClick={handleUpdateType}>
                                Update Type
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditClothing;
